module.exports = __webpack_public_path__ + "static/media/YM90_1.f23b3a8f.jpg";